import { useSyncExternalStore } from 'react';

/** Điện thoại: < 768px (Tailwind `md`). Dùng để đổi bảng thành danh sách thẻ, bộ lọc thành ngăn kéo. */
export const MOBILE_QUERY = '(max-width: 767px)';

function subscribe(cb: () => void) {
  const m = window.matchMedia(MOBILE_QUERY);
  m.addEventListener('change', cb);
  return () => m.removeEventListener('change', cb);
}

export const useIsMobile = () =>
  useSyncExternalStore(
    subscribe,
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false,
  );
